import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Metadata } from '@wf/components';
import { BarChartComponent, ChartCutOffValueSettings, ChartMetadata, LineChartComponent } from '@wf/components';
import { ChartType } from 'Shared/app/models/ChartType';
import { IChartCutOffValue } from 'Shared/app/models/IChartCutOffValue';
import { DynamicFormChart } from 'Shared/app/models/DynamicFormChart';

@Component({
  selector: 'wfs-dynamic-form-chart-wrapper',
  templateUrl: './dynamic-form-chart-wrapper.component.html',
  styleUrls: ['./dynamic-form-chart-wrapper.component.scss'],
  imports: [BarChartComponent, LineChartComponent]
})
export class DynamicFormChartWrapperComponent implements OnInit, OnChanges {
  @Input() chart?: DynamicFormChart;
  @Input() answers: number[][] = [];
  @Input() labels: string[] = [];
  @Input() series: string[] = [];
  @Input() listenOnChanges = false;

  protected metadata = {} as Metadata;
  protected chartCutOffValues: ChartCutOffValueSettings[] = [];
  protected errorText: string | undefined;

  ngOnInit() {
    this.checkForError();
    if (!this.errorText) {
      this.mapChartValues();
    }
  }

  ngOnChanges() {
    this.checkForError();

    if (this.listenOnChanges && !this.errorText) {
      this.mapChartValues();
    }
  }

  private checkForError() {
    if (!this.series || this.series.length === 0) {
      this.errorText = 'Inga beräkningar tillagda';
      return;
    }
    if (!this.chart || this.chart.maxValue == null || this.chart.minValue == null) {
      this.errorText = 'Minvärde och maxvärde är inte satt';
      return;
    }
    if (this.chart.minValue >= this.chart.maxValue) {
      this.errorText = 'Maxvärde måste vara större än minvärde';
      return;
    }
    this.errorText = undefined;
  }

  private mapChartValues() {
    if (!this.chart) {
      return;
    }

    this.metadata = {
      title: this.chart.title ?? undefined,
      minValue: this.chart.minValue,
      maxValue: this.chart.maxValue,
      showLegend: this.chart.type === ChartType.LineChart
    } satisfies ChartMetadata;

    if (this.chart.formChartCutOffValues) {
      this.chartCutOffValues = this.chart.formChartCutOffValues.map((cv: IChartCutOffValue) => {
        return {
          value: cv.value,
          label: cv.label,
          labelColor: 'black',
          color: 'grey',
          style: 'dash'
        } satisfies ChartCutOffValueSettings;
      });
    }
  }
}
